/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VmAgentsQueryCrowdStrikeStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("VmAgentsQueryCrowdStrikeStatus");
    }

    getFixupPrototypeFunction() { return VmAgentsQueryCrowdStrikeStatus.fixupPrototype; }

    static newInstance(model: Partial<VmAgentsQueryCrowdStrikeStatus>): VmAgentsQueryCrowdStrikeStatus {
        let obj = Object.assign(new VmAgentsQueryCrowdStrikeStatus(), model);
        VmAgentsQueryCrowdStrikeStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VmAgentsQueryCrowdStrikeStatus>): VmAgentsQueryCrowdStrikeStatus {
        if (!model) return null;
        return VmAgentsQueryCrowdStrikeStatus.newInstance(<VmAgentsQueryCrowdStrikeStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VmAgentsQueryCrowdStrikeStatus) {
        if (!obj) return;

        models.VmAgentsQueryCrowdStrikeStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VmAgentsQueryCrowdStrikeStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VmAgentsQueryCrowdStrikeStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Crowdstrike Installation Status
     */
    crowdstrike_status: Array<models.InstallationStatus>;

}
